import bills from './bills'
import code from './code'
import team from './team'
import terms from './terms'
import user from './user'
import contract from './contract'
import product from './product'
import customer from './customer'
import dashboard from "./dashboard"
import locale from './locale'
import notice from './notice'
import servicerequest from './servicerequest'

export default {
  bills,
  code,
  team,
  terms,
  user,
  contract,
  product,
  customer,
  dashboard,
  locale,
  notice,
  servicerequest
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js